import { useEffect, useState } from 'react';

export const useKetchConsent = (purposeKey: string) => {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.ketch !== 'function') {
      setAllowed(null);
      return;
    }

    const handler = (consent: any) => {
      const ok = consent?.purposes?.[purposeKey] === true;
      setAllowed(ok);
    };

    try {
      window.ketch('once', 'consent', handler);
      window.ketch('on', 'consent', handler);
    } catch (e) {
      console.error('Error reading Ketch', e);
    }

    return () => {
      try {
        window.ketch('off', 'consent', handler);
      } catch (e) {
        console.warn('Error detaching Ketch consent listener', e);
      }
    };
  }, [purposeKey]);

  return allowed;
};
